const data = [
    {
        id: 1,
        img: "https://i.ibb.co/KcPdgHx/1.jpg"
    },
    {
        id: 2,
        img: "https://i.ibb.co/T4MnJjr/2.jpg"
    },
    {
        id: 3,
        img: "https://i.ibb.co/tmSg5gm/3.jpg"
    },
    {
        id: 4,
        img: "https://i.ibb.co/7G1Wr6k/4.jpg"
    },
    {
        id: 5,
        img: "https://i.ibb.co/XZQL4Qd/5.jpg"
    },
    {
        id: 6,
        img: "https://i.ibb.co/4KS92kL/6.jpg"
    },
    {
        id: 7,
        img: "https://i.ibb.co/XJSLs1S/7.jpg"
    },
    {
        id: 8,
        img: "https://i.ibb.co/YZccrCr/8.jpg"
    },
    {
        id: 9,
        img: "https://i.ibb.co/7NBZ9rz/9.jpg"
    },
    {
        id: 10,
        img: "https://i.ibb.co/QJ29NL8/1.jpg"
    }
]

export default data